// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_g7-j";
export var fulfillmentFormRail = "_g7-i";
export var headerTitleRow = "_g7-l";
export var orderDetailsWrapper = "_g7-g";
export var orderLinkTrigger = "_g7-2";
export var paymentInformationGrid = "_g7-q";
export var paymentSummaryColumn = "_g7-r";
export var phoneShipmentPickerButton = "_g7-e";
export var phoneShipmentPickerButtonContent = "_g7-f";
export var phoneShipmentPickerButtonWrapper = "_g7-d";
export var phoneShipmentPickerTrigger = "_g7-c";
export var shipmentContainer = "_g7-k";
export var shipmentDetailsMainPane = "_g7-h";
export var shipmentNavigationCard = "_g7-a";
export var shipmentNavigationEdgeTrigger = "_g7-6";
export var shipmentNavigationRail = "_g7-3";
export var shipmentNavigationRailEnter = "_g7-5";
export var shipmentNavigationRailHeader = "_g7-9";
export var shipmentNavigationRailOverlay = "_g7-4";
export var shipmentNavigationScrim = "_g7-7";
export var shipmentSummaryFact = "_g7-n";
export var shipmentSummaryGrid = "_g7-m";
export var shipmentSummaryMetadataRow = "_g7-o";
export var shipmentSummaryTags = "_g7-p";
export var shipmentWorkspace = "_g7-0";
export var shipmentWorkspaceBodyTablet = "_g7-8";
export var shipmentWorkspaceContent = "_g7-b";
export var shipmentWorkspaceHeader = "_g7-1";